module.exports = __webpack_public_path__ + "img/mtc_svg_white.ea3f964c.svg";